import React from 'react';
import ReactDOM from 'react-dom';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import rootReducer from './reducers';
import App from './components/App';
import * as serviceWorker from './serviceWorker';
import GlobalStyle from './globalStyles'
import FontStyles from "./fontStyles";


const store = createStore(rootReducer);
ReactDOM.render(
    <Provider store={store}>
        <GlobalStyle />
        <FontStyles />
        <App />
    </Provider>,
    document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register();
